// extracted by mini-css-extract-plugin
module.exports = {"container":"_448ace5","legendsWrap":"_f9e85ac","title":"_dd65b02"};